
class NotTheModuleYouAreLookingFora extends Error {};

throw new Error("You want to load a subdirectory")

export default {};